// ModalPortal.js
import ReactDOM from 'react-dom';
import AudioModal from 'basic/modals/audiomodal';
import BasicPdfRender from 'basic/basicutils/basicpdfrender';
import TextModal from 'basic/basicutils/notesmodal';

const ModalPortal = ({
  isAudioOpen,
  audioSrc,
  onAudioClose,
  loading,

  isPdfOpen,
  onPdfClose,
  pdfBlob,
  pdfData,

  isTextOpen,
  onTextClose,
  notes,
}) => {
  return ReactDOM.createPortal(
    <>
      <AudioModal open={isAudioOpen} onClose={onAudioClose} audioSrc={audioSrc} loading={loading} />
      <BasicPdfRender ispdfshow={isPdfOpen} setIspdfShow={onPdfClose} pdfBlob={pdfBlob} data={pdfData} />
      <TextModal isOpen={isTextOpen} setTextModal={onTextClose} notes={notes} />
    </>,
    document.body
  );
};

export default ModalPortal;
